"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-next-line
var fetchMock;

var StorybookMockFetch = /*#__PURE__*/function (_React$Component) {
  _inherits(StorybookMockFetch, _React$Component);

  var _super = _createSuper(StorybookMockFetch);

  function StorybookMockFetch() {
    _classCallCheck(this, StorybookMockFetch);

    return _super.apply(this, arguments);
  }

  _createClass(StorybookMockFetch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      fetchMock = require("fetch-mock");
      this.mock();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (fetchMock.__prevProxy === this) {
        this.unmock();
      }
    }
  }, {
    key: "mock",
    value: function mock() {
      var _this = this;

      // Clear mocks from a previous StorybookMockFetch
      this.unmock();

      if (!this.props.mocks || !this.props.mocks.length) {
        return;
      }

      this.props.mocks.forEach(function (mock) {
        fetchMock.mock(_objectSpread(_objectSpread({}, mock), {}, {
          response: function response() {
            var response = _this.mockResponse(mock);

            return response;
          }
        }));
      }); // Allow unmocked requests to fall through

      fetchMock["catch"](function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return fetchMock.realFetch.apply(window, args);
      });
      fetchMock.__prevProxy = this;
    }
  }, {
    key: "mockResponse",
    value: function mockResponse(mockRequest) {
      var _this2 = this;

      var result = {
        body: mockRequest.response,
        headers: new Headers({
          "content-type": "application/json"
        })
      };

      if (mockRequest.response.hasOwnProperty("body") || mockRequest.response.hasOwnProperty("status") || mockRequest.response.hasOwnProperty("headers")) {
        result = _objectSpread(_objectSpread({}, result), mockRequest.response);
      }

      return this.props.throttle ? new Promise(function (resolve) {
        setTimeout(function () {
          return resolve(result);
        }, _this2.props.throttle);
      }) : result;
    }
  }, {
    key: "unmock",
    value: function unmock() {
      if (typeof fetchMock.restore === "function") {
        fetchMock.restore();
        delete fetchMock.__prevProxy;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return StorybookMockFetch;
}(_react["default"].Component);

exports["default"] = StorybookMockFetch;

_defineProperty(StorybookMockFetch, "displayName", "StorybookMockFetch");

_defineProperty(StorybookMockFetch, "defaultProps", {
  throttle: 300
});